import React from 'react';
import '../../css/MarketplaceIcon.css';

export const MarketplaceIcon = ({ key, name, shortName, url, enabledIconSrc, disabledIconSrc }) => {
    return (
        <div key={key} className="marketplace-icon-container">
            {url ? (
                <a href={url} target="_blank" rel="noopener noreferrer">
                    <div className="marketplace-icon-wrapper">
                        <img
                            loading="lazy"
                            src={enabledIconSrc}
                            alt={`${name} marketplace icon`}
                            className="marketplace-icon"
                        />
                    </div>
                </a>
            ) : (
                <div className="marketplace-icon-wrapper">
                    <img
                        loading="lazy"
                        src={disabledIconSrc}
                        alt={`${name} marketplace icon`}
                        className="marketplace-icon"
                    />
                </div>
            )}
            <div className="marketplace-icon-name">{name}</div>
            <div className="marketplace-icon-short-name">{shortName}</div>
        </div>
    );
};
